import paronApi from '@/utils/paron-api'

export default {
    getAllArticles(page = 1, perPage = 60) {
        return paronApi.get(`article/all?page=${page}&per_page=${perPage}`)
    },

    getArticleById(id) {
        return paronApi.get(`article/${id}`)
    },

    createArticle(data) {
        return paronApi.uploadFile('article/new', data)
    },

    editArticleById(id, data) {
        return paronApi.uploadFile(`article/${id}/edit`, data)
    },

    deleteArticleById(id) {
        return paronApi.delete(`article/${id}`)
    }

}
